import { withStyles, styled } from "@material-ui/core"
import { TreeItem, TreeView } from "@material-ui/lab"
import { Collection } from "@type-r/models"
import { useLinked } from "@type-r/react"
import React from "react"
import { Directories, Directory } from "../../api/directories"
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import FolderIcon from '@material-ui/icons/Folder';
import { PopupDialog } from "lqx-react/src"
import { Button, Title } from "lqx-react/lib"
import { DigiTooltip } from "../../shared"

export const TreeListItem = ({ item, level, itemDisabled, selected }: { item: Directory, level: number, itemDisabled: (id: string) => boolean, selected: any }) => {

    const isDisabled = itemDisabled(item.dirPath) || item.isAlreadyInUse;

    const disabledTooltip = 'Path has already been selected by an existing connections';

    const itemContent = <div style={{
        cursor: isDisabled ? 'not-allowed' : 'pointer',
        color: isDisabled ? '#939393' : ''
    }}>
        <StyledFolderIcon htmlColor="#58c1ee" />
        <span>{item.name}</span>
    </div>

    return <StyledTreeItem
        level={level}
        onLabelClick={(event) => {
            event.preventDefault();

            if (!isDisabled) {
                selected.set(item.dirPath);
            }
        }}
        nodeId={item.dirPath}
        disabled={isDisabled}
        label={isDisabled ? <DigiTooltip title={disabledTooltip}>{itemContent}</DigiTooltip> : itemContent} >
        {item.nestedNodes && item.nestedNodes.length > 0 && item.nestedNodes.map((item) => <TreeListItem itemDisabled={itemDisabled} key={item.dirPath} item={item} level={level + 1} selected={selected} />)}
    </StyledTreeItem>
}

export const TreeList = ({ list, selected, disabledIds }: { list: Collection<Directory>, selected: any, disabledIds: string[] }) => {
    const isItemDisabled = (id: string) => {
        return !!disabledIds.find((v) => v === id);
    }
    return <>
        {list && list.length > 0 &&
            <TreeView
                multiSelect={false}
                selected={selected.value}
                defaultCollapseIcon={<ExpandMoreIcon />}
                defaultExpandIcon={<ChevronRightIcon />}>
                {list.map((item) => <TreeListItem itemDisabled={isItemDisabled} key={item.dirPath} item={item} level={0} selected={selected} />)}
            </TreeView>}
    </>
}

export const FilePathPickerModal = ({ title, directories, onClose, onConfirm, disabledIds }
    : { title: string, directories: Directories, onClose: () => void, onConfirm: (val: string) => void, disabledIds: string[] }) => {

    const selected = useLinked(null);

    return (
        <>
            <PopupDialog
                title={<Title> {title} </Title>}
                actions={
                    <>
                        <Button onClick={onClose}>
                            Close
                        </Button>
                        <Button disabled={!selected.value} onClick={() => onConfirm(selected.value)}>
                            Add Path
                        </Button>
                    </>
                }
                maxWidth='lg'
                onClose={onClose}
            >
                <ModalContent>
                    <TreeListHeader>Folder Name</TreeListHeader>
                    <TreeList list={directories.list} selected={selected} disabledIds={disabledIds} />
                </ModalContent>

            </PopupDialog>
        </>
    );
};

const StyledFolderIcon = styled(FolderIcon)({
    margin: '0 4px'
})

const StyledTreeItem = withStyles({
    content: {
        maxWidth: '100%',
        borderBottom: "1px solid #dee3e6",
        backgroundColor: 'white'
    },
    label: {
        padding: '8px 4px',
        color: 'black',
        fontSize: '13px',
        fontStyle: 'normal',
        fontWeight: 500,
        overflow: 'hidden',
        whiteSpace: 'nowrap',
        textOverflow: 'ellipsis',
        backgroundColor: 'transparent!important',
        '&:hover': {
            color: '#3d6889',
            backgroundColor: 'transparent!important'
        }
    },
    group: {
        padding: 0,
        margin: 0
    },
    root: {
        '&[disabled] > div:first-child': {
            backgroundColor: '#b8b8b8!important'
        }
    },
    selected: {
        backgroundColor: 'transparent!important',
        '& > div:first-child': {
            backgroundColor: '#dbe6ee!important'
        },
        '& .MuiTreeItem-content .MuiTreeItem-label': {
            backgroundColor: 'transparent!important'
        },
    },
    iconContainer: {
        color: '#3d6889',
        paddingLeft: (props: any) => props.level * 24 + 12
    }
})(TreeItem)

const ModalContent = styled('div')({
    minHeight: 400,
    border: '1px solid #dce4e8',
    display: 'flex',
    flexDirection: 'column',
    overflow: 'auto'
})

const TreeListHeader = styled('div')({
    padding: '2px 4px',
    backgroundColor: '#3d6889',
    color: 'white'
})
